// format date to a human-readable format 15 mar 2023
export function formatDate(date: Date|string): string {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    };
    return new Intl.DateTimeFormat('en-US', options).format(date);
}